/** App-Bereiche: Verwaltung (s-admin) / Lehrer / Schüler / Eltern (plus Legacy privat|personal). */

export const AREA_LABEL = {
  verwaltung: 'Verwaltung',
  lehrer: 'Lehrkraft',
  schueler: 'Schüler',
  eltern: 'Eltern',
  personal: 'Lehrkraft',
  privat: 'Schüler',
};

export const AREA_HINT = {
  verwaltung: 's-admin · Desktop-Verwaltung',
  lehrer: 'Personal · Dateien & Anwesenheit',
  schueler: 'Privat · Community & Tools',
  eltern: 'Zahler:in · Abrechnungen & Nachrichten',
  personal: 'Personal · Dateien & Anwesenheit',
  privat: 'Privat · Community & Tools',
};

export function isStaffArea(area) {
  return area === 'verwaltung' || area === 'lehrer' || area === 'personal';
}

export function isPortalArea(area) {
  return area === 'eltern' || area === 'schueler' || area === 'privat';
}

export function normalizeArea(stored, available) {
  const list = available.length ? available : ['schueler'];
  const mapped = {
    personal: 'lehrer',
    privat: list.includes('schueler') ? 'schueler' : (list.includes('eltern') ? 'eltern' : list[0]),
  };
  const n = mapped[stored] || stored;
  if (list.includes(n)) return n;
  if (n === 'lehrer' && list.includes('personal')) return 'personal';
  if ((n === 'schueler' || n === 'eltern') && list.includes('privat')) return 'privat';
  return list[0];
}

export function nextArea(current, available) {
  if (!available.length) return current;
  const i = available.indexOf(current);
  return available[(i < 0 ? 0 : i + 1) % available.length];
}
